// App
import { yieldCallback } from '@zillow/yield-callback';

// Hooks
import { usePageLinks } from './hooks';

// Misc /utils
import routeUtils from 'app/shared/utils/routeUtils';
import { PageLinker } from './styles';

type PaginationItemProps = {
  areaResourceId?: string;
  ariaCurrent?: 'page' | 'step' | 'location' | 'date' | 'time' | boolean;
  ariaLabel?: string;
  children?: React.ReactNode;
  isBold?: boolean;
  isDisabled?: boolean;
  linkToPage?: number;
  linkType?: string;
  isActive?: boolean;
  onPaginationItemClick?: () => void;
  query?: Record<string, string | number | boolean | undefined>;
  searchSlug?: string;
};

const PaginationItem = ({
  areaResourceId,
  ariaCurrent,
  ariaLabel,
  children,
  isBold,
  isDisabled = false,
  linkToPage,
  linkType = 'accent',
  isActive = false,
  onPaginationItemClick,
  query,
  searchSlug,
}: PaginationItemProps) => {
  const [makeLink] = usePageLinks();
  const pageLink = makeLink(linkToPage, query, routeUtils.buildAreaPath({ areaResourceId, searchSlug }));

  const yieldCallbackAndTransition = yieldCallback(() => {
    onPaginationItemClick?.();
    window.router.transitionTo(pageLink);
  });

  const handlePageNavClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent the browser from going through with its default <a> behavior
    e.preventDefault();

    yieldCallbackAndTransition();
  };

  return (
    <PageLinker
      tabIndex={0}
      aria-label={ariaLabel}
      aria-current={ariaCurrent}
      aria-disabled={isDisabled}
      disabled={isDisabled}
      isActive={isActive}
      isBold={isBold}
      onClick={handlePageNavClick}
      linkType={linkType}
      to={pageLink}
    >
      {children}
    </PageLinker>
  );
};

export default PaginationItem;
